module.exports = __webpack_public_path__ + "img/eye.76801944.svg";